import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'decimal'
})
export class DecimalAreaRestritaPipe implements PipeTransform {
    transform(value: number): string {
        if (value) {
            return value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
        } else {
            return value.toString();
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/decimal.pipe.ts